var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIgSetting = function SvgIgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M5.625 9.997a1.459 1.459 0 1 1-2.917 0 1.459 1.459 0 0 1 2.917 0m11.667 0a1.458 1.458 0 1 1-2.917 0 1.458 1.458 0 0 1 2.917 0M10 11.456a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917",
    clipRule: "evenodd"
  })));
};
export default SvgIgSetting;